import React from 'react'
import useConfig from 'modules/config/state/use-config'
import useOrder from 'modules/order/state/order/use-order'
import useStripePaymentRequest from 'utils/functions/useStripePaymentRequest'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { usePrefetchPlaidToken } from 'redux/services/plaid'
import configSlice from 'modules/config/state/config-slice'
import { usePayPalFundingEligibility } from 'modules/flow/components/payment-methods-step/hooks/use-paypal-funding-eligibility'
import { PaymentMethod } from 'models/ChargeIntent'

/**
 * Prefetch & preload Stripe, Digital Wallets, Paypal token
 */
const useInitializePaymentMethods = () => {
  const dispatch = useDispatch()
  const order = useOrder()
  const config = useConfig()

  const campaignId = useMemo(() => config.campaignId, [config.campaignId])
  const currency = useMemo(() => order.currency.value, [order.currency.value])

  usePrefetchPlaidToken(campaignId, currency)

  // Remove Venmo from active payment methods if it's not eligible despite org supporting it
  // (also preloads paypal/venmo stuff)
  const { isLoaded, isVenmoEligible } = usePayPalFundingEligibility()

  React.useEffect(() => {
    if (isLoaded && !isVenmoEligible) {
      dispatch(configSlice.actions.removeActivePaymentMethod(PaymentMethod.Venmo))
    }
  }, [isLoaded, isVenmoEligible])

  // Initialize digital wallets
  useStripePaymentRequest()
}

export default useInitializePaymentMethods
